
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  template: `
    <h2 class="product-result-overview-header">
    ‘{{ searchText }}’ {{ additionalTitle }}
    </h2>
  `
})
export default class SearchTitle extends Vue {
  @Prop() additionalTitle: string
  params = new URLSearchParams()

  get searchText(): string {
    const result = this.params.has('q') ? this.params.get('q') : ''
    if(result === null) return ''
    return result
  }

  created(){
    const uri = window.location.search.replace('?', '')
    this.params =  new URLSearchParams(uri);
  }
}
